import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaiurbaniaonrent() {



    const cardData =
    {
        keyword: 'Pune to Mumbai Urbania On Rent',
        heading: 'Urbania on rent in pune: Pune to Mumbai Urbania On Rent',
        headingDescription: 'Urbania On Rent in Pune offers reliable and comfortable Pune to Mumbai Urbania On Rent services for families, corporate groups, tourists, and event travelers commuting between the two cities. Our well-maintained Force Urbania fleet provides spacious seating, air-conditioned comfort, and smooth performance, making it ideal for one-way and round-trip travel, airport transfers, corporate tours, and group journeys from Pune to Mumbai. With professional chauffeurs, flexible rental options, and convenient doorstep pickup from all major areas of Pune including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and stress-free intercity travel experience. Supported by 24/7 booking assistance, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the preferred choice for Urbania hire from Pune to Mumbai.',

        top: 'Top Places to Visit in Mumbai with Urbania on rent in pune',


 "topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India is Mumbai’s most iconic monument, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this grand Indo-Saracenic stone arch once served as the ceremonial entry point for British governors. Today, it is a lively tourist hub offering ferry rides to Elephanta Island, coastal photography, street food, and a vibrant promenade atmosphere. The monument looks especially stunning when illuminated at night, symbolizing Mumbai’s historic and cultural identity."
  },
  {
    "title": "Marine Drive (Queen’s Necklace)",
    "description": "Marine Drive is a 3.6 km-long coastal boulevard famous for its curved shape that resembles a necklace when lit up at night. Lined with Art Deco buildings, it is perfect for morning walks, jogging, cycling, and relaxing while enjoying sea breezes. Sunsets here paint the sky in beautiful colors, while nights offer a calm yet lively vibe. It remains one of Mumbai’s most loved spots for locals and tourists alike."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "CSMT is a UNESCO World Heritage Site and one of India’s finest examples of Victorian Gothic Revival architecture blended with Indian design. Built in 1887, it features grand domes, turrets, stained glass windows, and intricate stone carvings. Apart from being a busy railway station, it is a historical and architectural landmark that reflects Mumbai’s colonial past and modern energy."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular beaches, known for its lively atmosphere, street food, and sunset views. Visitors enjoy snacks like pav bhaji, bhel puri, and gola while watching street performers and kite flyers. The beach is also close to many Bollywood celebrity homes, adding to its charm. It is ideal for evening walks, family outings, and experiencing Mumbai’s coastal lifestyle."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Shree Siddhivinayak Temple in Prabhadevi is one of India’s most revered temples dedicated to Lord Ganesha. Known as a wish-fulfilling shrine, it attracts thousands of devotees daily, including celebrities and political leaders. The temple’s gold-plated sanctum and Ashtavinayak carvings enhance its spiritual aura. During Ganesh Chaturthi, the entire area becomes vibrant with devotion and celebrations."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a beautiful Indo-Islamic shrine located on a small islet connected to the mainland by a narrow causeway. Dedicated to Sufi saint Pir Haji Ali Shah Bukhari, it is surrounded by the sea on all sides. The white marble structure, spiritual ambiance, and scenic sea views attract visitors of all religions, making it a symbol of Mumbai’s cultural harmony."
  },
  {
    "title": "Elephanta Caves",
    "description": "The Elephanta Caves, a UNESCO World Heritage Site, are located on Elephanta Island and feature ancient rock-cut sculptures primarily dedicated to Lord Shiva. Dating back to the 5th–8th centuries, the caves showcase masterpieces like the Trimurti sculpture. Visitors reach the island by ferry from the Gateway of India, combining history, art, and a scenic boat ride."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a modern cable-stayed bridge connecting South Mumbai with the western suburbs. Offering stunning views of the Arabian Sea and city skyline, it is an engineering marvel and a symbol of Mumbai’s urban growth. The bridge looks especially spectacular during sunrise, sunset, and nighttime illumination."
  },
  {
    "title": "Chor Bazaar",
    "description": "Chor Bazaar is one of Mumbai’s oldest and most famous flea markets, known for antiques, vintage furniture, old cameras, Bollywood posters, and rare collectibles. Walking through its narrow lanes offers a glimpse into the city’s trading history and old-world charm. It is a paradise for bargain hunters, collectors, and photography enthusiasts."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park is a vast green sanctuary spread over 100 sq km within Mumbai city limits. It is home to leopards, deer, monkeys, and diverse bird species, along with the ancient Kanheri Caves. Visitors can enjoy nature trails, safaris, cycling tracks, and boating, making it a perfect escape from urban life."
  },
  {
    "title": "Mount Mary Church",
    "description": "Mount Mary Basilica, located in Bandra, is a beautiful Roman Catholic church known for its Gothic architecture and peaceful hilltop setting. The annual Bandra Fair attracts thousands of devotees and tourists. The church offers scenic views of the sea and surrounding areas, providing a calm spiritual retreat amidst the bustling city."
  }
],



"services": [
    {
      "name": "Pune to Mumbai Urbania on Rent",
      "description": "Pune to Mumbai Urbania on Rent provides comfortable and reliable Urbania vehicles for intercity travel between Pune and Mumbai. Ideal for families, corporate travelers, and groups, this service offers spacious seating, air-conditioned comfort, ample luggage space, and professional chauffeurs to ensure a smooth, safe, and stress-free highway journey."
    },
    {
      "name": "Urbania Hire Pune to Mumbai",
      "description": "Urbania Hire Pune to Mumbai offers dependable transportation solutions for frequent and occasional travelers. With well-maintained vehicles, trained chauffeurs, and flexible travel options, passengers can enjoy a comfortable and punctual journey suitable for business trips, leisure travel, and group outings."
    },
    {
      "name": "Urbania Bus Rental Pune to Mumbai",
      "description": "Urbania Bus Rental Pune to Mumbai provides spacious buses for large groups, corporate teams, and family tours. Designed for highway comfort, these buses feature comfortable seating, luggage capacity, and professional drivers, ensuring an organized and enjoyable journey between Pune and Mumbai."
    },
    {
      "name": "Urbania AC Bus Pune to Mumbai",
      "description": "Urbania AC Bus Pune to Mumbai offers fully air-conditioned buses for maximum comfort during long-distance travel. Ideal for corporate groups, tourists, and families, the service ensures a relaxing ride with climate control, spacious interiors, and experienced chauffeurs."
    },
    {
      "name": "Pune Mumbai Urbania One Way Hire",
      "description": "Pune Mumbai Urbania One Way Hire provides flexible travel options for passengers needing a single-direction journey. With clean vehicles, professional drivers, and punctual service, it ensures a convenient, cost-effective, and hassle-free travel experience from Pune to Mumbai."
    },
    {
      "name": "Pune Mumbai Urbania Round Trip Hire",
      "description": "Pune Mumbai Urbania Round Trip Hire delivers complete round-trip transportation solutions for business meetings, family visits, and group travel. With reliable scheduling, comfortable vehicles, and experienced chauffeurs, passengers can enjoy a seamless journey to Mumbai and back to Pune."
    },
    {
      "name": "Corporate Urbania Pune to Mumbai",
      "description": "Corporate Urbania Pune to Mumbai provides professional transportation for executives, business teams, and corporate events. Featuring executive comfort, air-conditioned vehicles, and trained chauffeurs, it ensures punctual, safe, and efficient intercity travel for corporate clients."
    },
    {
      "name": "Family Tour Urbania Pune to Mumbai",
      "description": "Family Tour Urbania Pune to Mumbai offers spacious and comfortable vehicles for family vacations and group outings. With ample luggage space, courteous chauffeurs, and smooth ride quality, families can enjoy a relaxed and enjoyable journey between the two cities."
    },
    {
      "name": "Luxury Urbania Pune to Mumbai",
      "description": "Luxury Urbania Pune to Mumbai provides premium travel experience with high-end interiors, superior comfort, and professional chauffeur service. Ideal for VIPs, executives, and travelers seeking luxury, it guarantees a stylish, smooth, and stress-free highway journey."
    },
    {
      "name": "Affordable Urbania Pune to Mumbai",
      "description": "Affordable Urbania Pune to Mumbai delivers cost-effective intercity travel solutions without compromising on comfort or safety. Suitable for families, groups, and budget-conscious travelers, it offers clean vehicles, reliable service, and experienced drivers."
    },
    {
      "name": "Chauffeur Driven Urbania Pune to Mumbai",
      "description": "Chauffeur Driven Urbania Pune to Mumbai ensures stress-free travel with trained and background-verified drivers. Vehicles are well-maintained and highway-ready, allowing passengers to relax and enjoy a safe, comfortable, and punctual journey."
    },
    {
      "name": "Pune Mumbai Urbania Travel Service",
      "description": "Pune Mumbai Urbania Travel Service provides end-to-end intercity transportation for leisure, corporate, and group travel. With dependable vehicles, professional chauffeurs, and customer-focused service, it ensures a smooth and comfortable travel experience."
    },
    {
      "name": "Best Urbania Hire Pune to Mumbai",
      "description": "Best Urbania Hire Pune to Mumbai offers top-rated Urbania rental services known for reliability, vehicle quality, and customer satisfaction. Ideal for families, corporate teams, and frequent travelers, it guarantees a safe and pleasant journey."
    },
    {
      "name": "Pune to Mumbai Urbania Booking",
      "description": "Pune to Mumbai Urbania Booking allows easy and convenient reservations for one-way or round-trip travel. With multiple vehicle options, professional chauffeur service, and flexible scheduling, passengers can plan their intercity journey with confidence."
    },
    {
      "name": "Urbania for Outstation Trip Pune to Mumbai",
      "description": "Urbania for Outstation Trip Pune to Mumbai provides reliable long-distance transportation with spacious seating and experienced chauffeurs. Ideal for family trips, corporate travel, and group outings, the service focuses on safety, comfort, and punctuality throughout the journey."
    }
  ],
  "tableData": [
    ["Pune to Mumbai Urbania on Rent", "Urbania Hire Pune to Mumbai"],
    ["Urbania Bus Rental Pune to Mumbai", "Urbania AC Bus Pune to Mumbai"],
    ["Pune Mumbai Urbania One Way Hire", "Pune Mumbai Urbania Round Trip Hire"],
    ["Corporate Urbania Pune to Mumbai", "Family Tour Urbania Pune to Mumbai"],
    ["Luxury Urbania Pune to Mumbai", "Affordable Urbania Pune to Mumbai"],
    ["Chauffeur Driven Urbania Pune to Mumbai", "Pune Mumbai Urbania Travel Service"],
    ["Best Urbania Hire Pune to Mumbai", "Pune to Mumbai Urbania Booking"],
    ["Urbania for Outstation Trip Pune to Mumbai", ""]


  ],



"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Mumbai Urbania On Rent",
        "WhyChoosedescription": "Pune to Mumbai Urbania On Rent is ideal for comfortable and spacious group travel, perfect for family trips, corporate travel, airport transfers, and outstation journeys."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Force Urbania Vehicles",
        "WhyChoosedescription": "Pune to Mumbai Urbania On Rent offers well-maintained Force Urbania vehicles with ample seating and luggage space, ensuring a smooth and relaxed highway journey."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Pune to Mumbai Urbania On Rent comes with skilled drivers familiar with the Pune–Mumbai expressway and city routes, ensuring safe, timely, and stress-free travel."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Pricing",
        "WhyChoosedescription": "Choose Pune to Mumbai Urbania On Rent for competitive rates with no hidden charges, making intercity group travel reliable and budget-friendly."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Pune to Mumbai Urbania On Rent provides round-the-clock assistance for bookings, schedule changes, and last-minute travel requirements."
    },
    {
        "WhyChooseheading": "Flexible Intercity Travel Packages",
        "WhyChoosedescription": "Pune to Mumbai Urbania On Rent is available for one-way trips, round trips, corporate travel, airport transfers, and customized intercity packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All Urbania vehicles for Pune to Mumbai travel are regularly cleaned, sanitized, and serviced to ensure a safe and comfortable journey."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Pune to Mumbai Urbania On Rent guarantees on-time pickups and dependable service, ensuring smooth and stress-free intercity travel."
    }
]
}

const faqData = [
    {
        question: 'Is Pune to Mumbai Urbania On Rent available for one-way and round trips?',
        answer: 'Yes, Pune to Mumbai Urbania On Rent is available for one-way, round-trip, and customized intercity travel packages.',
    },
    {
        question: 'How can I book Pune to Mumbai Urbania On Rent?',
        answer: 'You can book Pune to Mumbai Urbania On Rent via phone, WhatsApp, or online for quick and hassle-free reservations.',
    },
    {
        question: 'Why choose Pune to Mumbai Urbania On Rent for group travel?',
        answer: 'Pune to Mumbai Urbania On Rent offers spacious seating, ample luggage space, and a smooth ride, making it ideal for family, corporate, and group travel.',
    },
    {
        question: 'Is Pune to Mumbai Urbania On Rent suitable for airport transfers?',
        answer: 'Yes, Pune to Mumbai Urbania On Rent is perfect for Mumbai and Pune airport transfers for families and corporate travelers.',
    },
    {
        question: 'Are drivers experienced with Pune to Mumbai Urbania On Rent?',
        answer: 'Yes, all drivers are professionally trained, licensed, and experienced in handling Force Urbania vehicles on the Pune–Mumbai route.',
    },
    {
        question: 'Can I customize pickup and drop-off locations?',
        answer: 'Absolutely. Pune to Mumbai Urbania On Rent allows flexible pickup and drop-off locations across Pune and Mumbai.',
    },
    {
        question: 'Is Pune to Mumbai Urbania On Rent available 24x7?',
        answer: 'Yes, Pune to Mumbai Urbania On Rent operates 24x7 to meet intercity travel needs at any time.',
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all vehicles are regularly cleaned, sanitized, and maintained with strict safety protocols for every trip.',
    },
    {
        question: 'What payment options are available?',
        answer: 'Pune to Mumbai Urbania On Rent accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey to ensure a smooth and stress-free travel experience.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Nilesh Deshpande',
        feedback: 'We booked Pune to Mumbai Urbania On Rent for a family trip. The vehicle was spacious, clean, and the journey was very comfortable. Excellent service!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Aarti Kulkarni',
        feedback: 'Pune to Mumbai Urbania On Rent provided reliable and punctual service for our corporate travel. The driver was professional and experienced. Highly recommended!',
        rating: 5,
    },
];




































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Urbania On Rent",
  "image": "https://urbaniaonrentpune.in/assets/images/pune-to-mumbai-urbania.jpg",
  "description": "Pune to Mumbai Urbania On Rent offers AC and non-AC Urbania buses for one-way or round-trip travel between Pune and Mumbai. Ideal for corporate trips, family tours, and luxury travel, chauffeur-driven buses ensure safe, comfortable, and convenient transportation for outstation journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/pune-to-mumbai-urbania-on-rent"
  }
};








    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Pune to Mumbai Urbania On Rent | AC & Luxury Urbania Bus Rental 
  </title>

  <meta
    name="description"
    content="Book Pune to Mumbai Urbania On Rent for one-way or round-trip travel between Pune and Mumbai. AC and non-AC Urbania buses with chauffeur-driven service ensure safe, comfortable, and convenient outstation travel for corporate trips, family tours, and luxury journeys."
  />

  <meta
    name="keywords"
    content="Pune to Mumbai Urbania on Rent, Urbania Hire Pune to Mumbai, Urbania Bus Rental Pune to Mumbai, Urbania AC Bus Pune to Mumbai, Pune Mumbai Urbania One Way Hire, Pune Mumbai Urbania Round Trip Hire, Corporate Urbania Pune to Mumbai, Family Tour Urbania Pune to Mumbai, Luxury Urbania Pune to Mumbai, Affordable Urbania Pune to Mumbai, Chauffeur Driven Urbania Pune to Mumbai, Pune Mumbai Urbania Travel Service, Best Urbania Hire Pune to Mumbai, Pune to Mumbai Urbania Booking, Urbania for Outstation Trip Pune to Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/49.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomumbaiurbaniaonrent;